/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-05-28 22:05:38
 * @LastEditors: Raoxf
 * @LastEditTime: 2023-04-08 10:05:58
 */
const userInfo = JSON.parse(window.localStorage.getItem("userInfo") || "{}");
console.log(userInfo);
const typeMap = {
  1: "普通用户",
  2: "保洁员",
  3: "运营人员",
  4: "运营人员",
};
export default (Vue) => {
  return [
    {
      title: "账号/昵称",
      key: "nickName",
      width: 200,
      align: "center",
    },
    {
      title: "手机号",
      width: 200,
      key: "phone",
      align: "center",
    },
    {
      title: "角色",
      key: "companyName",
      align: "center",
      width: 100,
      render: (h, { row }) => {
        return h("div", row.nickName == "admin" ? "管理员" : typeMap[row.type]);
      },
    },
    {
      title: "创建时间",
      key: "createDt",
      align: "center",
    },
    {
      title: "最近一次登录时间",
      key: "lastTime",
      align: "center",
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      align: "center",
      width: 180,
      render: (h, { row }) => {
        return h(
          "div",
          [1, 3].includes(Number(userInfo.type)) &&
            row.nickName != "admin" &&
            row.type != "2"
            ? [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color: "#3091FF",
                    },
                    on: {
                      click: () => {
                        Vue.formData = row;
                        Vue.showBindDialog = true;
                      },
                    },
                  },
                  "查看商户"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color: "#3091FF",
                    },
                    on: {
                      click: () => {
                        Vue.$confirm("确认删除?", "提示", {
                          confirmButtonText: "确定",
                          cancelButtonText: "取消",
                          type: "warning",
                        })
                          .then(async () => {
                            await Vue.$post("/user/delete", {
                              userIds: row.userId,
                            });
                            Vue.$Notice.success({ title: "删除成功" });
                            Vue.getUserList();
                          })
                          .catch(() => {
                            this.$message({
                              type: "info",
                              message: "已取消删除",
                            });
                          });
                      },
                    },
                  },
                  "删除"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color: "#3091FF",
                    },
                    on: {
                      click: () => {
                        Vue.$confirm("确认重置密码?", "提示", {
                          confirmButtonText: "确定",
                          cancelButtonText: "取消",
                          type: "warning",
                        })
                          .then(async () => {
                            await Vue.$post("/user/addOrEdit", {
                              ...row,
                              password: "qnaj123456",
                            });
                            Vue.$Notice.success({ title: "重置成功" });
                            Vue.getUserList();
                          })
                          .catch(() => {
                            this.$message({
                              type: "info",
                              message: "已取消操作",
                            });
                          });
                      },
                    },
                  },
                  "重置密码"
                ),
              ]
            : []
        );
      },
    },
  ];
};
